import { useState } from "react";
import { Menu, X } from "lucide-react"; // Using Lucide React for icons
import Branding from "./Branding";

const appUrl = process.env.REACT_APP_ANDROID_APP_URL;

const Header = ({ home }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav
      className="p-4 sticky top-0 z-50 bg-white"
      style={{ color: "#0c2b49" }}
    >
      <div className="container mx-auto flex justify-between items-center px-4">
        {/* Brand/Logo Section */}
        <div className="text-white text-2xl font-bold font-inter rounded-md p-2">
          <Branding />
        </div>

        {/* Mobile Menu Button (Hamburger/Close Icon) */}
        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            className="focus:outline-none focus:ring-2 rounded-md p-2"
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Desktop Navigation Links */}
        <div className="hidden md:flex space-x-6 items-center">
          {home ? (
            <>
              <a
                href="/#home"
                className=" font-medium hover:text-[#0c2b49] transition-colors duration-300 rounded-md px-3 py-2"
              >
                Home
              </a>
              <a
                href="/#features"
                className=" font-medium hover:text-[#0c2b49] transition-colors duration-300 rounded-md px-3 py-2"
              >
                Features
              </a>

              <a
                href="/#working"
                className=" font-medium hover:text-[#0c2b49] transition-colors duration-300 rounded-md px-3 py-2"
              >
                Working
              </a>
              <a
                href="/#plans"
                className=" font-medium hover:text-[#0c2b49] transition-colors duration-300 rounded-md px-3 py-2"
              >
                Plans
              </a>
              <a
                href="/#testimonials"
                className=" font-medium hover:text-[#0c2b49] transition-colors duration-300 rounded-md px-3 py-2"
              >
                Testimonials
              </a>
            </>
          ) : (
            <a
              href="/resources"
              className=" font-medium hover:text-[#0c2b49] transition-colors duration-300 rounded-md px-3 py-2"
            >
              Resources
            </a>
          )}
          <a
            target="_blank"
            href={appUrl}
            className=" font-medium hover:text-[#0c2b49] transition-colors duration-300 rounded-md px-3 py-2"
          >
            <button className="bg-gradient-to-r from-blue-900 to-pink-700">
              Download App
            </button>
          </a>
          {/* <a
            href="/login"
            className=" font-medium hover:text-blue-200 transition-colors duration-300 rounded-md px-3 py-2"
          >
            <button>Login</button>
          </a> */}
        </div>
      </div>

      {/* Collapsible Mobile Menu */}
      {/* Conditionally renders based on 'isOpen' state for small screens */}
      <div
        className={`${
          isOpen ? "block" : "hidden"
        } md:hidden bg-[#f2f8fd] py-2 mt-2 rounded-lg mx-4 shadow-inner`}
      >
        {home ? (
          <>
            <a
              href="/#home"
              className="block text-[#0c2b49]  font-medium px-6 py-3 hover:text-[#0c2b49] transition-colors duration-200 rounded-md"
            >
              Home
            </a>
            <a
              href="/#features"
              className="block text-[#0c2b49]  font-medium px-6 py-3 hover:text-[#0c2b49] transition-colors duration-200 rounded-md"
            >
              Features
            </a>
            <a
              href="/#working"
              className="block text-[#0c2b49]  font-medium px-6 py-3 hover:text-[#0c2b49] transition-colors duration-200 rounded-md"
            >
              Working
            </a>
            <a
              href="/#plans"
              className="block text-[#0c2b49]  font-medium px-6 py-3 hover:text-[#0c2b49] transition-colors duration-200 rounded-md"
            >
              Plans
            </a>
            <a
              href="/#testimonials"
              className="block text-[#0c2b49]  font-medium px-6 py-3 hover:text-[#0c2b49] transition-colors duration-200 rounded-md"
            >
              Testimonials
            </a>{" "}
          </>
        ) : (
          <a
            href="/resources"
            className="block text-[#0c2b49]  font-medium px-6 py-3 hover:text-[#0c2b49] transition-colors duration-200 rounded-md"
          >
            Resources
          </a>
        )}
        <a
          target="_blank"
          href={appUrl}
          className="block text-[#0c2b49]  font-medium px-6 py-3 hover:text-[#0c2b49] transition-colors duration-200 rounded-md bg-gradient-to-r from-blue-900 to-pink-500"
        >
          Download App
        </a>
        {/* <a
          href="/login"
          className="block text-[#0c2b49]  font-medium px-6 py-3 hover:[#0c2b49] transition-colors duration-200 rounded-md"
        >
          Login
        </a> */}
      </div>
    </nav>
  );
};

export default Header;
